import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { makeAnalytics } from "./analytics.js";
import { AnalyticsContext, useAnalytics } from "./AnalyticsContext.js";
import { makeDefaultCookieConsentProvider } from "./cookie-consent.js";
import { makeAnalyticsTracker } from "./tracker.js";
/** Turns a granted marketing consent into the matching analytics event. */
function CookieConsentBridge({ provider }) {
    const analytics = useAnalytics();
    // Nothing navigates away on consent, so the emit is left to settle on its own.
    useEffect(() => provider.subscribe((consent) => {
        void analytics.cookieConsentGranted(consent);
    }), [analytics, provider]);
    return null;
}
export function AnalyticsProvider({ config, cookieConsentProvider, children, }) {
    const analytics = useMemo(() => makeAnalytics(makeAnalyticsTracker(config)), [
        config.seznamRtgId,
        config.analyticsEvents?.seznamConversion,
        config.gtmId,
        config.metaPixelId,
    ]);
    const provider = useMemo(() => cookieConsentProvider ?? makeDefaultCookieConsentProvider(), [cookieConsentProvider]);
    return (_jsxs(AnalyticsContext.Provider, { value: analytics, children: [_jsx(CookieConsentBridge, { provider: provider }), children] }));
}
